module.exports = __webpack_public_path__ + "static/media/Safety Map Icon.f110e064.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Safety Map Icon.png
// module id = 1277
// module chunks = 0